import moment from "antd/node_modules/moment";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  generateTimeIntervalsTradingTimes,
  isVenueOpen,
} from "../utils/tradingTimesObject";
import { canVenuePreorder } from "../utils/venuePreOrderAvailable";
import { useSnackbarMessages } from "../yoello-lib/modules/components/snackbar/SnackbarContext";
import T from "i18n-react";
import { SelectedOrderType } from "../Components/Payment/types.d";

export function useVenueOpen(showSnackMessages = true) {
  const Venue = useSelector((state: any) => state.Venue);
  const { sendSnackbarMessage } = useSnackbarMessages()!;
  const OrderType = useSelector((state: any) => state.SelectedMenuType);
  const [isOpen, setIsOpen] = useState(false);
  useEffect(() => {
    if (!Venue) {
      return;
    }
    const day = moment().format("dddd").toLowerCase();
    const tradingTimes = Venue?.trading_times;
    let isOpenVenue = false;
    if (tradingTimes && day in tradingTimes) {
      const todayTradingTimes = tradingTimes[day];

      const deliveryTimes = generateTimeIntervalsTradingTimes(
        todayTradingTimes,
        Venue.delivery_max_lead_time
      );
      const collectionTimes = generateTimeIntervalsTradingTimes(
        todayTradingTimes,
        Venue.food_prep_time
      );
      if (
        canVenuePreorder(
          Venue,
          tradingTimes,
          deliveryTimes,
          collectionTimes,
          OrderType
        ) &&
        Venue?.enabled === true
      ) {
        sendMessage(
          T.translate("ShopCart.Errors.PreOrderOnly") as string,
          "info"
        );
        isOpenVenue = true;
      } else if (isVenueOpen(tradingTimes) || Venue?.enabled === true) {
        if (!isVenueOpen(tradingTimes) || Venue?.enabled === false) {
          sendMessage(
            T.translate("ShopCart.Errors.VenueClosed") as string,
            "error"
          );
        }
        // if  the venue is about to close but still open then user can only view the menu
        else if (
          (OrderType === SelectedOrderType.CLICK &&
            collectionTimes.length === 0) ||
          (OrderType === SelectedOrderType.DELIVERY &&
            deliveryTimes.length === 0) ||
          (OrderType === SelectedOrderType.TABLE &&
            !isVenueOpen(tradingTimes, Venue.food_prep_time))
        ) {
          sendMessage(getCanOnlyViewErrorText(OrderType), "error");
        } else {
          isOpenVenue = true;
        }
      } else {
        sendMessage(
          T.translate("ShopCart.Errors.VenueClosed") as string,
          "error"
        );
      }
      if (isOpen !== isOpenVenue) {
        setIsOpen(isOpenVenue);
      }
    }
    //eslint-disable-next-line
  }, [Venue, OrderType]);
  function sendMessage(message: string, status: any) {
    if (showSnackMessages) {
      sendSnackbarMessage(message, status);
    }
  }
  return isOpen;
}

function getCanOnlyViewErrorText(SelectedMenuType): string {
  if (SelectedMenuType === SelectedOrderType.CLICK) {
    return T.translate("ShopCart.Errors.NoCollectionTimes") as string;
  } else if (SelectedMenuType === SelectedOrderType.DELIVERY) {
    return T.translate("ShopCart.Errors.NoDeliveryTimes") as string;
  } else if (SelectedMenuType === SelectedOrderType.TABLE) {
    return T.translate("ShopCart.Errors.NoServiceAvailable") as string;
  }
  return "";
}
